export const SELECT = 'SELECT';
export const DESELECT = 'DESELECT';
export const SELECT_ALL = 'SELECT_ALL';
export const DESELECT_ALL = 'DESELECT_ALL';
export const PAGE_SIZE = 'PAGE_SIZE';
export const TABLE_DATA = 'TABLE_DATA';
export const TABLE_DATA2 = 'TABLE_DATA2';

